// extracted by mini-css-extract-plugin
export default {"genericCard":"xr-z","inline":"yr-z","mastercard":"zr-z","discover":"Ar-z","visa":"Br-z","amex":"Cr-z","active":"Dr-z"};